import { useState, useEffect } from "react";
import { Star } from "lucide-react";
import { api } from "../api/api";
import Swal from "sweetalert2";

const Ratings = ({ totalStars = 5, ratingType, rating, setRating, vehicle, setShowToast, isLoggedIn, userId }) => {
  const [hover, setHover] = useState(0);
  const [hasAcceptedBooking, setHasAcceptedBooking] = useState(false);

  // Check if user has an accepted booking for this vehicle
  useEffect(() => {
    if (isLoggedIn && ratingType === 'Customer' && userId) {
      api.get(`/bookings/checkUserBooking?userId=${userId}&vehicleId=${vehicle._id}`)
        .then(response => {
          setHasAcceptedBooking(response.data.hasAcceptedBooking);
        })
        .catch(error => {
          console.error("Error checking user booking:", error);
          setHasAcceptedBooking(false);
        });
    }
  }, [isLoggedIn, ratingType, userId, vehicle._id]);

  const handleClick = (index) => {
    // Check if user is logged in for Customer rating
    if (ratingType === 'Customer' && !isLoggedIn) {
      Swal.fire({
        icon: 'info',
        title: 'You must be logged in!',
        text: 'Please login to rate this vehicle as Customer. Otherwise you can rate as Fan.',
        confirmButtonColor: '#6f48e5',
      });
      return;
    }
    
    // Check if user has an accepted booking for Customer rating
    if (ratingType === 'Customer' && isLoggedIn && !hasAcceptedBooking) {
      Swal.fire({
        icon: 'info',
        title: 'Booking Required',
        text: 'You need to have an accepted booking for this vehicle to rate as a Customer.',
        confirmButtonColor: '#6f48e5',
      });
      return;
    }
    
    // Proceed with rating
    setRating(index);
    
    api.post("/vehicles/updaterating", { 
      vehicleId: vehicle._id, 
      ratingType, 
      rating: index,
      userId: userId // Adding userId to identify the user who rated
    }).then((response) => {
      console.log(response.data);
    }).catch((error) => console.log(error));
    
    setShowToast(true);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-row space-x-1">
        {[...Array(totalStars)].map((_, index) => {
          const starValue = index + 1;
          return (
            <Star
              key={index}
              className={`w-4 h-4 cursor-pointer transition-all duration-300 ${
                starValue <= (hover || rating) ? "text-[#6F48E5]" : "text-[#A9B9E3]"
              }`}
              onClick={() => handleClick(starValue)}
              onMouseEnter={() => setHover(starValue)}
              onMouseLeave={() => setHover(0)}
              fill={starValue <= (hover || rating) ? "currentColor" : "none"}
              strokeWidth={1.5}
            />
          );
        })}
      </div>
      <div className="text-gray-500">Rate as {ratingType}</div>
    </div>
  );
};

export default Ratings;